import api from "app/api";
import settings from "app/settings";

export interface LoginForm {
  email: string;
  password: string;
}

export interface AccountBundle {
  paid_begin: string;
  paid_end: string;
  begin: string;
  end: string;
  name: string;
  type: string;
  price: number;
  user_limit: number;
  waiver_limit: number;
  storage_limit: number;
  submit_limit: number;
  location_limit: number;
  created_at: string;
  next_billing_date: string;
  next_billing_price: string;
  next_billing_type: string;
}


export function login(item: LoginForm) {
  return api.post(
    settings.loginUrl,
    {
      username: item.email,
      password: item.password,
      client_type: "web",
    },
    {public: true}
  );
}

export function logout() {
  return api.post(settings.logoutUrl);
}


export function getAccountBundle() {
  return api.get('/account/account-bundle');
}